import { Pipe, PipeTransform } from '@angular/core';
import { ActivityVerbEnum } from '@shared/model/enum/activity-verb-enum';
import { ObjectTypeEnum } from '@shared/model/enum/object-type-enum';

@Pipe({
  name: 'userImageIcon',
  standalone: true
})
export class UserImageIconPipe implements PipeTransform {

  transform(verb: ActivityVerbEnum, objectType?: ObjectTypeEnum, isInside?: boolean): string {
    let icon = '';
    switch (verb) {
      case ActivityVerbEnum.Reviewed:
        icon = 'notepad-edit-regular'
        break;
      case ActivityVerbEnum.ReadingProgressed:
      case ActivityVerbEnum.StateChangedIWantToRead:
      case ActivityVerbEnum.StateChangedToCurrently:
      case ActivityVerbEnum.StateChangedToRead:
        icon = 'book bg-green-50 text-green-500'
        break;
      case ActivityVerbEnum.Posted:
        icon = 'compose-regular'
        break;
      case ActivityVerbEnum.Rated:
        icon = 'star-filled'
        break;
      case ActivityVerbEnum.Quoted:
        icon = 'text-quote-filled'
        break;
      case ActivityVerbEnum.Commented:
        if (!isInside) {
          icon = 'comment-regular';
        }
        else {
          icon = this.checkObjectType(objectType!);
        }
        break;
      case ActivityVerbEnum.Liked:
        icon = this.checkObjectType(objectType!);
        break;
      case ActivityVerbEnum.Booklisted:
        icon = 'apps-list-filled';
        break;
      case ActivityVerbEnum.ClubInvited:
      case ActivityVerbEnum.Clubed:
      case ActivityVerbEnum.ClubJoinRequestAccepted:
      case ActivityVerbEnum.ClubJoinRequested:
        icon = 'people-team-regular';
        break;
      case ActivityVerbEnum.ChallengePicked:
      case ActivityVerbEnum.ChallengeObtained:
      case ActivityVerbEnum.AchievementObtained:
        icon = 'ribbon-star-regular';
        break;
    }
    return icon;
  }

  checkObjectType(objectType: ObjectTypeEnum): string {
    let icon = '';
    if (objectType === ObjectTypeEnum.Review)
      icon = 'notepad-edit-regular';
    if (objectType === ObjectTypeEnum.Rate)
      icon = 'star-filled';
    else if (objectType === ObjectTypeEnum.Progress)
      icon = 'book';
    else if (objectType === ObjectTypeEnum.Booklist)
      icon = 'apps-list-filled';
    else if (objectType === ObjectTypeEnum.Post)
      icon = 'compose-regular';
    else if (objectType === ObjectTypeEnum.Quote)
      icon = 'text-quote-filled';
    else if (objectType == ObjectTypeEnum.Club)
      icon = 'people-team-regular';
    else if (objectType == ObjectTypeEnum.ChallengeV2 || objectType == ObjectTypeEnum.UserChallenge)
      icon = 'ribbon-star-regular';

    return icon;
  }

}
